"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BotaoDePagina = void 0;
var react_1 = __importDefault(require("react"));
var rebass_1 = require("rebass");
var classnames_1 = __importDefault(require("classnames"));
var BotaoDePagina = function (_a) {
  var ativo = _a.ativo,
    rotulo = _a.rotulo,
    onClick = _a.onClick;
  return react_1.default.createElement(rebass_1.Flex, {
    className: classnames_1.default({
      ativo: ativo
    }, "botao-de-pagina"),
    onClick: onClick,
    sx: {
      cursor: "pointer",
      fontFamily: "heading",
      fontWeight: "bold",
      borderColor: "blue2",
      color: "blue2",
      borderRadius: 999,
      borderStyle: "solid",
      borderWidth: 2,
      justifyContent: "center",
      alignItems: "center",
      width: 40,
      height: 40,
      transition: "color, background-color 0.1s ease",
      "&.ativo": {
        color: "white",
        cursor: "pointer",
        backgroundColor: "blue2"
      }
    }
  }, rotulo);
};
exports.BotaoDePagina = BotaoDePagina;